export const initShareBtn = (btnElement, link) => {
    const linkToShare = link || btnElement.dataset.link

    if (!linkToShare) {
        console.error('Share link is undefined.')
        return
    }

    btnElement.addEventListener('click', () => {
        if (navigator.share) {
            navigator.share({url: linkToShare})
        } else {
            navigator.clipboard.writeText(linkToShare)
        }
    })
}
